import Vue from 'vue';
import VueRouter from 'vue-router';


Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'login',
    component:  () => import( '../views/Login.vue'),
  },

    {
        path: '/login',
        name: 'login',
        component: () => import( '../views/Login.vue'),
    },
    {
        path: '/index',
        name: 'index',
        component: () => import( '../views/Index.vue'),
    },
    {
        path: '/consultation/record',
        name: 'conrecord',
        component: () => import( '../views/consultation/Record.vue'),
    },
    {
        path: '/consultation/remind',
        name: 'conremind',
        component: () => import( '../views/consultation/Remind.vue'),
    },
    {
        path: '/reserve/remind',
        name: 'resremind',
        component: () => import( '../views/reserve/Remind.vue'),
    },
    {
        path: '/reserve/record',
        name: 'resrecord',
        component: () => import( '../views/reserve/Record.vue'),
    },
    {
        path: '/reserve/query',
        name: 'resquery',
        component: () => import( '../views/reserve/Query.vue'),
    },
    {
        path: '/reserve/weddingrecords',
        name: 'weddingrecords',
        component: () => import( '../views/reserve/Weddingrecords.vue'),
    },
    {
        path: '/financial/wedding',
        name: 'fwedding',
        component: () => import( '../views/financial/Wedding.vue'),
    },
    {
        path: '/financial/reserve',
        name: 'freserve',
        component: () => import( '../views/financial/Reserve.vue'),
    },
    {
        path: '/financial/reservecommission',
        name: 'freservecommission',
        component: () => import( '../views/financial/ReserveCommission.vue'),
    },
    {
        path: '/financial/weddingcommission',
        name: 'fweddingcommission',
        component: () => import( '../views/financial/WeddingCommission.vue'),
    },
    // {
    //     path: '/financial/reconciliation',
    //     name: 'freconciliation',
    //     component: () => import( '../views/financial/Reconciliation.vue'),
    // },
    {
        path: '/financial/weddingconfirm',
        name: 'fweddingconfirm',
        component: () => import( '../views/financial/WeddingConfirm.vue'),
    },
    {
        path: '/financial/reserveconfirm',
        name: 'freserveconfirm',
        component: () => import( '../views/financial/ReserveConfirm.vue'),
    },
    {
        path: '/settings/base',
        name: 'setbase',
        component: () => import( '../views/settings/Base.vue'),
    },
    {
        path: '/settings/date',
        name: 'setdate',
        component: () => import( '../views/settings/Date.vue'),
    },
    {
        path: '/settings/extra',
        name: 'setextra',
        component: () => import( '../views/settings/Extra.vue'),
    },
    {
        path: '/settings/field',
        name: 'setfield',
        component: () => import( '../views/settings/Field.vue'),
    },
    {
        path: '/settings/order',
        name: 'setorder',
        component: () => import( '../views/settings/Order.vue'),
    },
    {
        path: '/settings/setmeal',
        name: 'setmeal',
        component: () => import( '../views/settings/Setmeal.vue'),
    },
    {
        path: '/settings/user',
        name: 'setuser',
        component: () => import( '../views/settings/User.vue'),
    },
    {
        path: '/settings/role',
        name: 'setrole',
        component: () => import( '../views/settings/Role.vue'),
    },
    {
        path: '/settings/commission',
        name: 'setcommission',
        component: () => import( '../views/settings/Commission.vue'),
    }
    ,
    {
        path: '/member/info',
        name: 'memberinfo',
        component: () => import( '../views/member/Info.vue'),
    }
    ,
    {
        path: '/member/category',
        name: 'membercategory',
        component: () => import( '../views/member/Category.vue'),
    } ,
    {
        path: '/member/consume',
        name: 'memberconsume',
        component: () => import( '../views/member/Consume.vue'),
    },
    {
        path: '/member/recharge',
        name: 'memberrecharge',
        component: () => import( '../views/member/Recharge.vue'),
    },
    {
        path:'/statistics/report',
        name:'statisticsreport',
        component: () => import( '../views/statistics/Report.vue'),
    }

];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
